import { Injectable } from '@angular/core';
// Toastr Global settings set in App Module
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  constructor(private toastrService: ToastrService) {}

  displaySuccess(message: string) {
    this.toastrService.success(message)
  }

  displayError(error: string | Array<string>) {
    if (Array.isArray(error)) {
      error.forEach((err) => {
        this.toastrService.error(err)
      })
    } else {
      this.toastrService.error(error);
    }
  }

  displayWarning(message: string) {
    this.toastrService.warning(message);
  }

  displayInfo(message: string) {
    this.toastrService.info(message);
  }
}
